import React from 'react';
import {Snackbar} from '@mui/material';
import {Alert} from '@mui/lab';

const CusttomSnackbar = ({message, open, handleChange, type}) => {
    return (
        <Snackbar
            open={open}
            onClose={() => {
                handleChange(type)
            }}
            autoHideDuration={type === 'error' ? 4000 : 1000}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}>
            <Alert
                elevation={6}
                variant="filled"
                severity={type}
                onClose={() => {
                    handleChange(type)
                }}>
                {message}
            </Alert>
        </Snackbar>
    )
}

export default CusttomSnackbar;
